import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types';
import axios from 'axios'
import Swal from 'sweetalert2'
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container'
import TextField from '@material-ui/core/TextField';
import DateFnsUtils from '@date-io/date-fns';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';

import Biodata from './Biodata'
import WorkingProfile from './Working'
import onSubmitEducation from './onSubmitEducation'
import onSubmitBiodata from './onSubmitBiodata'
import onSubmitWorking from './onSubmitWorking'
import ProvinsiData from '../Biodata/ProvinsiData'
import KabupatenData from '../Biodata/KabupatenData'
import Header from '../Element/Header'
import { uploadCv, uploadIjazah } from './onUpload'

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        marginTop: '5%'
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    root: {
        height: '110vh'
    },
    grid: {
        '& .MuiFormControl-fullWidth': {
            marginTop: '5%'
        }
    },
    root_tab: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function Profile() {
    const classes = useStyles();
    const history = useHistory();
    const [user, setUser] = useState([])
    const [biodata, setBiodata] = useState([])
    const [province, setProvince] = useState('')
    const [districts, setDistricts] = useState('')
    const [viewDistricts, setViewDistricts] = useState([])
    const [disabledBiodata, setDisabledBiodata] = useState(true)
    const [editBiodata, setEditBiodata] = useState(false)
    const [disabledEducation, setDisabledEducation] = useState(true)
    const [editEducation, setEditEducation] = useState(false)
    const [disabledWorking, setDisabledWorking] = useState(true)
    const [editWorking, setEditWorking] = useState(false)
    const [working, setWorking] = useState([])
    const [value, setValue] = React.useState(0);

    useEffect(() => {
        async function fetchData() {
            const token = localStorage.getItem('token');
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_API}/participant/profile/read`,
                headers: { token: token }
            };

            try {
                axios(config)
                    .then(function (response) {
                        setUser(response.data)
                        setBiodata(response.data.participant_biodatum)
                        setWorking(response.data.participant_working_experiences)
                        let provinsiFilter = ProvinsiData.filter(function (word) {
                            return response.data.participant_biodatum.provinsi === word.iso;
                        })

                        var kab_filter = KabupatenData.filter(function (word) {
                            return provinsiFilter[0].code === word.provinsi_id;
                        });

                        if (provinsiFilter !== []) {
                            setProvince(provinsiFilter[0])
                        }

                        if (kab_filter !== []) {
                            var kab_filter_input = KabupatenData.filter(function (word) {
                                return word.code === response.data.participant_biodatum.kabupaten
                            });
                            setViewDistricts(kab_filter)
                            setDistricts(kab_filter_input[0])
                        }
                    })
                    .catch(error => {
                        console.log('Error', error)
                        history.push('/participant/login')
                    })
            } catch (error) {
                console.log('Error', error)
                history.push('/participant/login')
            }
        }

        fetchData()
    }, [user.id, history]);

    const handleChangeProvince = async (event) => {
        let provinsi = ProvinsiData
        let kabupaten = KabupatenData

        let provinsiFilter = provinsi.filter(function (word) {
            return event.target.value.name === word.name;
        })

        var kab_filter = kabupaten.filter(function (word) {
            return provinsiFilter[0].code === word.provinsi_id;
        });

        setViewDistricts(kab_filter)
        setProvince(event.target.value)
    }

    const handleChangeDistricts = (event) => {
        setDistricts(event.target.value)
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeUploadCv = async (event) => {
        let resUploadCv = await uploadCv(event)
        setBiodata({
            ...biodata,
            cv: resUploadCv.data
        })
    }

    const handleChangeUploadIjazah = async (event) => {
        let resUploadIjazah = await uploadIjazah(event)
        setBiodata({
            ...biodata,
            ijazah: resUploadIjazah.data
        })
    }

    return (
        <Container maxWidth="md" className={classes.root}>
            <CssBaseline />
            <div className={classes.root}>
                <Header />
                <AppBar position="static">
                    <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                        <Tab label="Biodata" {...a11yProps(0)} />
                        <Tab label="Pendidikan" {...a11yProps(1)} />
                        <Tab label="Pekerjaan" {...a11yProps(2)} />
                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                    <Grid container spacing={3} className={classes.grid}>
                        <Grid item xs={12} sm={6}>
                            {Biodata(user)}
                            <FormControl variant="outlined" fullWidth >
                                <InputLabel shrink >Jenis Kelamin</InputLabel>
                                <Select
                                    value={biodata.gender != null ? biodata.gender : ""}
                                    disabled={disabledBiodata}
                                    onChange={e => setBiodata({
                                        ...biodata,
                                        gender: e.target.value
                                    })}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value={'L'}>Laki-Laki</MenuItem>
                                    <MenuItem value={'P'}>Perempuan</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                label="Tempat Lahir"
                                type="string"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                disabled={disabledBiodata}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    birth_place: e.target.value
                                })}
                                variant="outlined"
                                value={biodata.birth_place}
                            />
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    fullWidth
                                    required
                                    margin="normal"
                                    id="date-picker-dialog"
                                    label="Tanggal Lahir"
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    size="small"
                                    disableFuture
                                    openTo="year"
                                    format="dd/MM/yyyy"
                                    views={["year", "month", "date"]}
                                    value={biodata.birth_date}
                                    onChange={e => setBiodata({
                                        ...biodata,
                                        birth_date: e
                                    })}
                                    disabled={disabledBiodata}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Alamat"
                                type="string"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                disabled={disabledBiodata}
                                variant="outlined"
                                value={biodata.address}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    address: e.target.value
                                })}
                            />
                            <FormControl variant="outlined" fullWidth className={classes.input} size="small">
                                <InputLabel id="province" required>Provinsi</InputLabel>
                                <Select
                                    labelId="province"
                                    id="province"
                                    disabled={disabledBiodata}
                                    value={province}
                                    onChange={handleChangeProvince}
                                    label="Provinsi"
                                >
                                    {
                                        ProvinsiData.map((value, index) => {
                                            return (
                                                <MenuItem key={index} value={value}>{value.name}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl variant="outlined" fullWidth className={classes.input} size="small">
                                <InputLabel id="districts" required>Kabupaten</InputLabel>
                                <Select
                                    labelId="districts"
                                    id="districts"
                                    disabled={disabledBiodata}
                                    value={districts}
                                    onChange={handleChangeDistricts}
                                    label="districts"
                                >
                                    {
                                        viewDistricts.map((value, index) => {
                                            return (
                                                <MenuItem key={index} value={value}>{value.name}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <TextField
                                label="Kecamatan"
                                type="string"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                disabled={disabledBiodata}
                                variant="outlined"
                                value={biodata.kecamatan}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    kecamatan: e.target.value
                                })}
                            />
                            <TextField
                                label="Kelurahan"
                                type="string"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                disabled={disabledBiodata}
                                variant="outlined"
                                value={biodata.kelurahan}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    kelurahan: e.target.value
                                })}
                            />
                            <TextField
                                label="Kode Pos"
                                type="string"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                disabled={disabledBiodata}
                                variant="outlined"
                                value={biodata.kodepos}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    kodepos: e.target.value
                                })}
                            />
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography>CV: {biodata.cv ? biodata.cv.split('-')[1] : 'Belum Di Upload'}</Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="label"
                                    fullWidth
                                >
                                    upload CV
                                    <input
                                        type="file"
                                        hidden
                                        onChange={handleChangeUploadCv}
                                        accept="application/pdf"
                                    />
                                </Button>
                                <Typography>Ijazah: {biodata.ijazah ? biodata.ijazah.split('-')[1] : 'Belum Di Upload'}</Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="label"
                                    fullWidth
                                >
                                    upload Ijazah
                                    <input
                                        type="file"
                                        hidden
                                        onChange={handleChangeUploadIjazah}
                                        accept="image/*"
                                    />
                                </Button>
                            </div>
                        </Grid>
                        {editBiodata ?
                            <div style={{ display: 'flex' }}>
                                <Button variant="contained" color="primary" onClick={() => onSubmitBiodata(biodata, setEditBiodata, setBiodata, setDisabledBiodata, province, districts)}>
                                    Submit Biodata
                                </Button>
                                <Button variant="contained" color="primary" style={{ marginLeft: '3%' }} onClick={() => {
                                    setDisabledBiodata(true)
                                    setEditBiodata(false)
                                }}>
                                    Batal
                                </Button>
                            </div> :
                            <div style={{ display: 'flex' }}>
                                <Button variant="contained" color="primary" onClick={() => {
                                    Swal.fire({
                                        title: 'Yakin mau edit biodata ?',
                                        showDenyButton: true,
                                        confirmButtonText: `Iya`,
                                        denyButtonText: `Batal`,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            setDisabledBiodata(false)
                                            setEditBiodata(true)
                                        }
                                    })
                                }}>
                                    Edit
                            </Button>
                            </div>
                        }
                    </Grid>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Grid container spacing={3} className={classes.grid} style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="outlined-multiline-static"
                                label="Prestasi & Kompetensi"
                                fullWidth
                                multiline
                                rows={5}
                                variant="outlined"
                                value={biodata.competency}
                                size="small"
                                disabled={disabledEducation}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    competency: e.target.value
                                })}
                            />
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="institution"
                                label="Institusi"
                                name="institution"
                                autoComplete="institution"
                                className={classes.input}
                                value={biodata.edu_institution}
                                size="small"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled={disabledEducation}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    edu_institution: e.target.value
                                })}
                            />

                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="last_education"
                                label="Pendidikan Terakhir"
                                name="last_education"
                                autoComplete="last_education"
                                className={classes.input}
                                value={biodata.edu_degree}
                                size="small"
                                helperText="Contoh: S1"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled={disabledEducation}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    edu_degree: e.target.value
                                })}
                            />

                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="majors"
                                label="Jurusan"
                                name="majors"
                                autoComplete="majors"
                                className={classes.input}
                                value={biodata.edu_major}
                                size="small"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled={disabledEducation}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    edu_major: e.target.value
                                })}
                            />

                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="graduation_year"
                                label="Tahun Lulus"
                                name="graduation_year"
                                autoComplete="graduation_year"
                                className={classes.input}
                                value={biodata.edu_grad_year}
                                size="small"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled={disabledEducation}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    edu_grad_year: e.target.value
                                })}
                            />

                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="GPA"
                                label="IPK"
                                name="GPA"
                                autoComplete="GPA"
                                className={classes.input}
                                value={biodata.edu_grade}
                                size="small"
                                helperText="Contoh: 3.45 (desimal menggunakan titik)"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled={disabledEducation}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    edu_grade: e.target.value
                                })}
                            />
                        </Grid>
                    </Grid>
                    <div>
                        {editEducation ?
                            <div style={{ display: 'flex' }}>
                                <Button variant="contained" color="primary" onClick={() => onSubmitEducation(biodata, setEditEducation, setBiodata, setDisabledEducation, province, districts)}>
                                    Submit Education
                                </Button>
                                <Button variant="contained" color="primary" style={{ marginLeft: '3%' }} onClick={() => {
                                    setDisabledEducation(true)
                                    setEditEducation(false)
                                }}>
                                    Batal
                                </Button>
                            </div> :
                            <div style={{ display: 'flex' }}>
                                <Button variant="contained" color="primary" onClick={() => {
                                    Swal.fire({
                                        title: 'Yakin mau edit biodata ?',
                                        showDenyButton: true,
                                        confirmButtonText: `Iya`,
                                        denyButtonText: `Batal`,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            setDisabledEducation(false)
                                            setEditEducation(true)
                                        }
                                    })
                                }}>
                                    Edit
                            </Button>
                            </div>
                        }
                    </div>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Grid container spacing={3} className={classes.grid}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                size="small"
                                label="Expected Salary"
                                value={biodata.expec_salary || ''}
                                disabled={disabledWorking}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    expec_salary: e.target.value
                                })}
                            />
                            <TextField
                                variant="outlined"
                                required fullWidth
                                size="small"
                                label="Nationality"
                                value={biodata.nationality || ''}
                                disabled={disabledWorking}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    nationality: e.target.value
                                })}
                            />
                            <TextField
                                required
                                fullWidth
                                variant="outlined"
                                size="small"
                                id="outlined-basic_1"
                                label="Soft Skills"
                                multiline
                                rows={4}
                                value={biodata.soft_skills || ''}
                                disabled={disabledWorking}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    soft_skills: e.target.value
                                })}
                            />
                            <TextField
                                required
                                fullWidth
                                variant="outlined"
                                size="small"
                                id="outlined-basic_2"
                                label="Hard Skills"
                                multiline
                                rows={4}
                                value={biodata.hard_skills || ''}
                                disabled={disabledWorking}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    hard_skills: e.target.value
                                })}
                            />
                            <TextField
                                required
                                fullWidth
                                variant="outlined"
                                size="small"
                                id="outlined-basic"
                                label="Hobbies Interest"
                                multiline
                                rows={4}
                                value={biodata.hobbies_interest || ''}
                                disabled={disabledWorking}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    hobbies_interest: e.target.value
                                })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                fullWidth
                                variant="outlined"
                                size="small"
                                id="outlined-basic"
                                label="Organization Experience"
                                multiline
                                rows={4}
                                value={biodata.org_exp || ''}
                                disabled={disabledWorking}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    org_exp: e.target.value
                                })}
                            />
                            <TextField
                                required
                                fullWidth
                                variant="outlined"
                                size="small"
                                id="outlined-basic"
                                label="Education Non Formal"
                                multiline
                                rows={4}
                                value={biodata.education_non_formal || ''}
                                disabled={disabledWorking}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    education_non_formal: e.target.value
                                })}
                            />
                            <TextField
                                required
                                fullWidth
                                variant="outlined"
                                size="small"
                                id="outlined-basic"
                                label="Current Role"
                                multiline
                                rows={4}
                                value={biodata.current_position || ''}
                                disabled={disabledWorking}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    current_position: e.target.value
                                })}
                            />
                            <TextField
                                required
                                fullWidth
                                variant="outlined"
                                size="small"
                                id="outlined-basic"
                                label="Notice Period"
                                multiline
                                rows={4}
                                value={biodata.notice_period || ''}
                                disabled={disabledWorking}
                                onChange={e => setBiodata({
                                    ...biodata,
                                    notice_period: e.target.value
                                })}
                            />
                        </Grid>
                    </Grid>
                    <div style={{ marginTop: '2%' }}>
                        {editWorking ?
                            <div style={{ display: 'flex' }}>
                                <Button variant="contained" color="primary" onClick={() => onSubmitWorking(biodata, setEditWorking, setBiodata, setDisabledWorking, province, districts)}>
                                    Submit Working
                                </Button>
                                <Button variant="contained" color="primary" style={{ marginLeft: '3%' }} onClick={() => {
                                    setDisabledWorking(true)
                                    setEditWorking(false)
                                }}>
                                    Batal
                                </Button>
                            </div> :
                            <div style={{ display: 'flex' }}>
                                <Button variant="contained" color="primary" onClick={() => {
                                    Swal.fire({
                                        title: 'Yakin mau edit biodata ?',
                                        showDenyButton: true,
                                        confirmButtonText: `Iya`,
                                        denyButtonText: `Batal`,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            setDisabledWorking(false)
                                            setEditWorking(true)
                                        }
                                    })
                                }}>
                                    Edit
                            </Button>
                            </div>
                        }
                    </div>
                    {WorkingProfile(user.id, working, setWorking)}
                </TabPanel>
            </div>
        </Container>
    );
}